import type {BankAccount} from './BankAccount';
import type {ContactInformation} from './ContactInformation';
import type {DeputyPerson} from './DeputyPerson';

export type BillingInformation = {
  id: string;
  billingName: string | null;
  isPrimary: boolean;
  contactInformation: ContactInformation | null;
  deputyPersons: Array<DeputyPerson>;
  bankAccounts: Array<BankAccount>;
};
